import { Frequency } from "rrule";

const FREQ_MAP: Record<number, Frequency> = {
  1: Frequency.DAILY,
  7: Frequency.WEEKLY,
  30: Frequency.MONTHLY,
  365: Frequency.YEARLY,
};

export default (cadence: number) => {
  const value = FREQ_MAP[cadence];

  if (value !== undefined) {
    return value;
  }

  throw new Error(`Undefined freq: ${cadence}`);
};
